import uidinput from '../../components/UidInputComponent.vue';
import airportselect from '../../components/AirportSelectComponent.vue';
import Form from '../../form';
import Errors from "../../errors";
import Vue from "vue";

let app = new Vue({
    el: '#app-vpindex',

    data: {
        form: new Form({
            uid: '',
            airport: '',
            payservice: false
        }),
        openbookings: []
    },

    components: {
        uidinput,
        airportselect
    },
    methods: {
        onSubmit() {
            this.form.post(document.getElementById('uidform').getAttribute('action'))
                .then(response => {
                    console.log(response);
                    if(response.open) {
                        swal({
                            type: 'warning',
                            text: 'Es existiert mindestens eine offene Buchung für diesen Kunden. Bitte schließen Sie diese Buchung zuerst ab.'
                        });
                        this.openbookings = response.open;
                        return;
                    }
                    if(response.target) {
                        document.getElementById('uidform').setAttribute('action', response.target);
                        document.getElementById('uidform').submit()
                    }
                })
                .catch();
        }
    }
});

export default app;